import { Module } from 'vuex';
import { DashboardState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: DashboardState = {
    taskList: undefined,
    taskCount: 0,
    alertList: undefined,
    systemMessageList: undefined,
    taskIndex: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    alertIndex: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    systemMessageIndex: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const dashboard: Module<DashboardState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
